<template>
  <div class="content">
    <s-location mypage title="소속변호사 권한 설정"/>
		<h4 class="sub_title02">소속변호사 권한 설정</h4>


    <div class="comment_gray expcomment mt_15">
      <p class="tit">소속변호사가 증표를 구입할 경우</p>
      <li>귀 법무법인에 속해있는 변호사가 본인 계정으로 증표를 구입할 경우 해당 증표의 사용 권한은 증표를 구입한 해당 변호사에게 귀속됩니다.</li>
      <li>다만, 해당 변호사가 본인 계정으로 구입한 증표는 법무법인 마스터 계정으로도 사용할 수 있습니다(같은 법무법인 내 다른 변호사 개인 계정으로는 사용 붇가)</li>
      <li>또한, 귀 법무법인에 속해있던 변호사가 개인 계정으로 구입한 증표 중 미사용 증표는 해당 회원의 소속이 바뀔 경우 변경된 소속으로 자동전환 됩니다</li>
      <li>(회원 소속정보 변경 내역은 다음날 반영됩니다.)</li>
    </div>


    <table class="tbl01">
      <colgroup>
        <col width="17%"/>
        <col/>
      </colgroup>
      <tr>
        <th>구분</th>
        <th>권한</th>
        <th>설명</th>
      </tr>
      <tr>
        <th>증표 구입</th>
        <td>
          <label><input type="checkbox" v-model="item.member_buy" true-value="1" false-value="0" :disabled="masterYn"/> 증표 구입 가능</label>
          <!-- 소속변호사가 증표 구입 -->
        </td>
        <td>
          소속변호사가 증표를 구입할 수 있음.
        </td>
      </tr>
      <tr>
        <th>미사용 증표 사용</th>
        <td>
          <!-- 법인아이디가 구입한 증표를 법인 아이디가 사용 -->
          <label><input type="checkbox" v-model="item.master_buy_member_use" true-value="1" false-value="0" :disabled="masterYn"/> 법인 등 증표 사용 가능</label>
          <!-- 법인이 구입한 증표를 소속변호사가 사용 -->
        </td>
        <td>
          소속변호사가 마스터 계정이 구입한 증표를 사용(내역 등록)할 수 있음.
        </td>
      </tr>
    </table>

    <div class="btn_group">
      <a v-if="!masterYn" @click="doSubmit" class="btn right" style="margin-left: 20px;">저장</a>
    </div>
  </div>
</template>

<style scoped>
table.tbl01 tr { height: 50px; }
table.tbl01 td { text-align: left;  padding-left: 8px; }
table.tbl01 label { cursor: pointer; }
</style>

<script>
let ui
export default {
  data() {
    return {
      item   : {},
      masterYn : true,
    }
  },

  created() {
    ui = this.$ui
    this.getData();
  },

  methods: {

    getData() {

      if(this.$store.state.session.user.type == 'master'){
        this.masterYn = false
      }

      // 로그인 계정의 권한 값 받아오기.
      ui.httpGet(
        "/proc/N_OFFICE_MEM_SEL_DTL", {},
        ret => {
          this.item = ret.data.rs1[0]
          }
        )
    },

    doSubmit(){
      ui.httpPost(
        "/proc_iv/N_OFFICE_MEM_UPD_DTL",
        {
          ...this.item
          , id : ''
          , approveyn : ''
        }, ret => {
            const {msg, status} = ret.data.rs1[0];
            this.$ui.notify(msg);
            if (status == '0') {
              this.getData()
            }
          }
        )

    },

  },
}
</script>